


































































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {Utils} from '@/utils/Utils';
import FilterMenu from '@/components/FilterMenu.vue';
import Paginition from '@/components/Paginition.vue';
import {Filter} from '@/utils/Filter';
import {API} from '@/services/api/api';
import {mapActions, mapGetters} from 'vuex';
import MonthlyStatistics from '@/views/Dashboard/Statistics/MonthlyStatisticsList.vue';
@Component({
  components: {
    FilterMenu,
    Paginition,
  },
  computed: {...mapGetters(['currentTab'])},

  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast', 'setCurrentTabActionPlan']),
  },
})
export default class InsapectionList extends Vue {
  //Props
  @Prop() listData!: any;
  @Prop({default: true}) filter: boolean;
  @Prop({default: true}) checkBox!: boolean;
  @Prop({default: true}) isLocationVisible!: boolean;
  @Prop({default: true}) isEditable!: boolean;
  @Prop({default: true}) isDeleteAble!: boolean;
  @Prop({default: true}) isDeleteEntireAble!: boolean;
  @Prop({default: true}) canReinspect!: boolean;
  @Prop({default: true}) canCreateActionPlan: boolean = true;

  selectedInspection = [];
  Utils = Utils;
  setCurrentTabActionPlan: any;
  currentTab: any;
  filteredListData = this.listData;
  startingPoint = 0; //pagination starting point
  endingPoint = 5; //pagination ending point
  curentSort = ''; //current sort on which header
  inspectionIds: any = null;
  showErrorToast: any;
  showSuccessToast: any;
  modalVisible = false;
  monthlyStatisticsList: MonthlyStatistics[];
  modalTitle = '';
  modalConfimationMsg = '';
  isSelectAll = false;
  deleteStatus = false;
  asdcOrder = true;

  isDeleteChildInspections = false;

  //TableHeader
  header = [
    {name: 'checkbox', value: 'checkbox'},
    {
      name: 'Inspection ID',
      value: 'inspectionCode',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: '#',
      value: 'totalInspections',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Ship',
      value: 'shipName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Deck',
      value: 'deckName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Frame',
      value: 'frameNumber',
      sortable: true,
      headerType: 'number',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Location',
      value: 'location',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Date',
      value: 'inspectionDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Inspector',
      value: 'inspectorName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Recipient',
      value: 'recipientUser',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Finding',
      value: 'finding',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Severity',
      value: 'severity',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },

    {
      name: 'Voyage',
      value: 'voyageName',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    // {
    //   name: 'Voyage Condition',
    //   value: 'voyageCondition',
    //   sortable: true,
    //   headerType: 'text',
    //   asdcOrder: true,
    //   filter: true,
    // },
    {
      name: 'Reinspection Date',
      value: 'reinspectionDate',
      sortable: true,
      headerType: 'date',
      asdcOrder: true,
      filter: true,
    },
    {name: '#', value: 'status', sortable: false, headerType: 'text'},

    {
      name: 'Work Order',
      value: 'workOrder',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    {
      name: 'Status',
      value: 'actionPlanStatus',
      sortable: true,
      headerType: 'text',
      asdcOrder: true,
      filter: true,
    },
    // {name: '#', value: 'view'},
    {name: '#', value: 'reinspection'},

    {name: 'Locate', value: 'locate'},
    {name: 'Edit', value: 'edit', bindClass: 'text-center'},
    {name: 'Delete', value: 'delete', bindClass: 'text-center'},
  ];

  //ResetFilter
  resetFilter() {
    this.filteredListData = this.listData;
    this.resetPagination();
  }

  //Show header as per condtions
  getHeader() {
    let canDelete = Utils.manageRoutePermissions('inspection', 4);
    let canEntireDelete = Utils.manageRoutePermissions('inspection', 5);

    let canReinspect = Utils.manageRoutePermissions('reinspection');
    let canCreateActionPlan = Utils.manageRoutePermissions('action');

    return this.header.filter((head) => {
      if (head.name === 'Location') {
        return this.isLocationVisible;
      } else if (head.name === 'Location') {
        return this.isLocationVisible;
      } else if (head.name === 'Edit') {
        return (this.isEditable = Utils.manageRoutePermissions('inspection', 3));
      } else if (head.name === 'Delete') {
        return (this.isDeleteAble = canDelete);
      } else if (head.name == 'checkbox') {
        return (this.checkBox = canDelete || canEntireDelete);
      } else if (head.value == 'reinspection') {
        return (this.canReinspect = canReinspect);
      } else if (head.name == 'Status') {
        return (this.canCreateActionPlan = canCreateActionPlan);
      } else {
        return true;
      }
    });
  }

  //Set background color in severity column
  getBackgroundColor(condition) {
    switch (condition) {
      case 'Medium':
        return '#FE9B0A';
      case 'High':
        return '#E23838';
      case 'Must See':
        return '#FB0AD7';
      case 'Low':
        return '#08D1FC';

      default: {
        return '#fff';
      }
    }
  }

  //Select all list
  checkAllCheckBox() {
    if (this.listData.length === this.selectedInspection.length) {
      this.selectedInspection = [];
      this.isSelectAll = false;
    } else {
      this.selectedInspection = this.listData.map((me: any) => me.inspectionID);
    }
  }

  //Add selected inspection in list
  addInspectionToList(isInspectionSelected, inspectionId) {
    if (!isInspectionSelected) {
      this.selectedInspection = this.selectedInspection.filter((a) => a !== inspectionId);
      this.isSelectAll = false;
    } else {
      this.selectedInspection.push(inspectionId);
    }
  }

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }
    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredListData);
    this.asdcOrder = sorted;
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  //filter methods
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.listData);

    this.filteredListData = filteredData;
    this.resetPagination();
  }

  //filter data based upon number parameters
  filterOnNumber(emittedFilterParams: any) {
    let filteredData = Filter.filterOnNumberData(emittedFilterParams, this.listData);

    this.filteredListData = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.listData);
    this.filteredListData = filteredData;
    this.resetPagination();
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  //Show Delete Modal
  onDeleteClick(recordId: number) {
    this.inspectionIds = recordId === undefined ? this.selectedInspection.join(',') : recordId;

    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure you want to delete this inspection ?';
    this.deleteStatus = true;
  }

  //Handle delete entire inspection
  onDeleteEntireClick() {
    this.isDeleteChildInspections = true;
    this.inspectionIds = this.selectedInspection.join(',');
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ? It will also remove re-inspections too.';
    this.deleteStatus = true;
  }

  //Handle delete API
  async onDeleteConfirm() {
    try {
      const response = this.isDeleteChildInspections
        ? await API.deleteEntireInspectionById(this.inspectionIds)
        : await API.deleteInspectionById(this.inspectionIds);
      if (response.message) {
        this.selectedInspection = [];
        this.showSuccessToast({msg: response.message});
        this.$emit('refreshList');
      } else {
        this.showErrorToast({msg: response.error});
        return response.error;
      }
    } catch (error) {
      this.showErrorToast({msg: error});
      return error;
    }
  }

  @Watch('listData', {immediate: true})
  mappListData(listData) {
    //
    this.filteredListData = listData;
  }

  //Navigate to action plan tab based upon input
  goToActionPlan(inspectionId, name) {
    const actionPlanStatus = name;

    switch (actionPlanStatus) {
      case 'Waiting For Action Plan':
        this.setCurrentTabActionPlan({
          parent: 'actionplan',
          child: 'actionplan',
          navigateTo: 'actionplan',
        });
        break;
      case 'Waiting For Implementation':
        this.setCurrentTabActionPlan({
          parent: 'actionplan',
          child: 'implementation',
          navigateTo: 'implementation',
        });
        break;
      case 'Waiting For Surveyor Approval':
        this.setCurrentTabActionPlan({
          parent: 'actionplan',
          child: 'surveyor',
          navigateTo: 'surveyor',
        });
        break;
      case 'Waiting Manager to Close':
        this.setCurrentTabActionPlan({
          parent: 'actionplan',
          child: 'verification',
          navigateTo: 'verification',
        });
        break;

      default:
        return false;
    }
    this.$router.push('/action-plan/' + inspectionId);
  }

  //Navigate to pages  based upon input

  navigateToPages(name, inspectionId) {
    switch (name) {
      case 'view':
        return this.$router.push(`/view-inspection/` + inspectionId);
      case 'edit':
        return this.$router.push('/edit-inspection/' + inspectionId);

      case 'reinspection':
        return this.$router.push('/re-inspection/' + inspectionId);

      case 'locateinspection':
        return this.$router.push('/locate-inspection/' + inspectionId);

      case 'inspectionhistory':
        return this.$router.push('/inspection-history/' + inspectionId);
    }
  }

  @Watch('selectedInspection', {immediate: true})
  ToggleDeleteBtns() {
    let deleteBtnsVisible = {
      delete: false,
      deleteEntire: false,
    };

    let deleteIns = Utils.manageRoutePermissions('inspection', 4);
    let deleteEntire = Utils.manageRoutePermissions('inspection', 5);
    //

    if (this.selectedInspection.length > 0 && deleteIns) {
      deleteBtnsVisible.delete = true;
      this.$emit('onCheckBoxChange', deleteBtnsVisible);
    }
    if (this.selectedInspection.length > 0 && deleteEntire) {
      deleteBtnsVisible.deleteEntire = true;
      this.$emit('onCheckBoxChange', deleteBtnsVisible);
    } else this.$emit('onCheckBoxChange', deleteBtnsVisible);
  }
}
